import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0A84FF",
      dark: "#0060DF",
      light: "#5AC8FA",
      contrastText: "#ffffff",
    },

    background: {
      default: "#F4F6F8",
      paper: "#ffffff",
    },

    text: {
      primary: "#0C1421",
      secondary: "#5A607F",
    },

    // divider: "#E6E8EF",
  },

  shape: {
    borderRadius: 7,
  },

  typography: {
    fontFamily: "Inter, sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarWidth: "thin",
          scrollbarColor: "#0A84FF transparent",
        },

        "*::-webkit-scrollbar": {
          width: "5px",
          height: "5px",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#0A84FF",
          borderRadius: "8px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#0060DF",
        },
        "*::-webkit-scrollbar-track": {
          background: "transparent",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 7,
          height: 36,
          paddingLeft: 14,
          paddingRight: 14,
        },
        containedPrimary: {
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
          "&:hover": {
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 7,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "unset",
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: "unset",
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
  },
});
